let code = 'ig';
let codeAPI = 'ig';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};